import { TGeoValue } from 'packages/JsonQuery';
import { getOrder } from './getOrder';

interface ISortGeoParams<T> {
  sortedGeoIds: TGeoValue[];
  sortedType: string;
  geoItems: T[];
}

export function sortGeo<T extends { id: number }>({ sortedGeoIds, sortedType, geoItems }: ISortGeoParams<T>) {
  const orderMap: Map<number, number> = sortedGeoIds
    .filter(item => item.type === sortedType)
    .reduce((map, item, index) => {
      map.set(item.id, index);

      return map;
    }, new Map<number, number>());

  /**
   * Сортируем согласно порядку полученному из geo.sortedGeoId
   * станции, по каким то причинам, не попавшие в geo.sortedGeoId, идут низшим приоритетом
   */
  return geoItems
    .concat()
    .sort(
      (a, b) => getOrder<number, number>(orderMap, a.id, Infinity) - getOrder<number, number>(orderMap, b.id, Infinity),
    );
}
